"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prose = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const react_string_replace_1 = __importDefault(require("react-string-replace"));
const constants_1 = require("./constants");
const prose_style_1 = __importDefault(require("./prose.style"));
class Prose extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.parseBoldMarkdown = () => react_string_replace_1.default(this.props.text, constants_1.PROSE_REGEX_MARKDOWN_BOLD, (match, i) => jsx_runtime_1.jsx("strong", { children: match }, `bold_${i}`));
        this.render = () => {
            const { classes, breakAfter, small, light } = this.props;
            const rootProps = {
                className: classes.root,
                'data-break-after': breakAfter,
                'data-is-small': small,
                'data-is-light': light
            };
            return jsx_runtime_1.jsx("p", Object.assign({}, rootProps, { children: this.parseBoldMarkdown() }), void 0);
        };
    }
}
exports.Prose = Prose;
Prose.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    text: prop_types_1.default.string.isRequired,
    breakAfter: prop_types_1.default.bool,
    small: prop_types_1.default.bool,
    light: prop_types_1.default.bool
};
Prose.defaultProps = {
    breakAfter: false,
    small: false,
    light: false
};
exports.default = react_jss_1.default(prose_style_1.default)(Prose);
//# sourceMappingURL=prose.js.map